import Window from "../Window";
import WebView from "../WebView";
import { useEffect } from "react";

const AppView = ({ id, app, closeWindow, handleAppMessage, onFocus }) => {
  useEffect(() => {
    window.addEventListener("message", handleAppMessage);
    return () => window.removeEventListener("message", handleAppMessage);
  }, [app]);
  return (
    <Window
      id={app.getHash()}
      top={0}
      left={0}
      name={app.getName()}
      onClick={onFocus}
      onCancel={closeWindow}
    >
      <WebView id={id} width={"100%"} height={"100%"} data={app.getData()} />
    </Window>
  );
};

export default AppView;
